export const PRICE_SUBSCRIPTION = '@@card_announcement/PRICE_SUBSCRIPTION';

export const ANNOUNCEMENT_LOAD = '@@card_announcement/ANNOUNCEMENT_LOAD';



// WEBPACK FOOTER //
// ./src/app/CardAnnouncement/actionTypes.js